import { AxiosRequestCustomConfig, AxiosResponse, RequestParameter } from 'libs/axios';
import { apiClient } from 'libs/helpers';

const uploadImage: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: '/images',
};
const uploadQuestionImage: AxiosRequestCustomConfig<RequestParameter, AxiosResponse> = {
  url: '/images/imagesQuestion',
};

export const uploadRepositories = {
  uploadImage: apiClient.postFn(uploadImage),
  uploadQuestionImage: apiClient.postFn(uploadQuestionImage),
};
